<template>
    <div class="container chartBackGround" >
        <div class="firstDiv0">
            <div class="custom-title">
                <el-form :inline="true" class="demo-form-inline">
                   <el-form-item label="申请类型">
                        <el-select
                          v-model="query.personflag"
                          style="width: 120px"
                        >
                        <el-option label="全部" value="" />
                        <el-option label="个人" value="1" />
                        <el-option label="企业" value="2" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="转贷经办">
                        <el-select
                          v-model="query.db"
                          style="width: 120px"
                        >
                        <el-option label="全部" value="" />
                            <el-option
                              v-for="item in dblist"
                              :key="item.UserID"
                              :label="item.UserName"
                              :value="item.UserID"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="银行初审">
                        <el-select
                          v-model="query.yh"
                          style="width: 120px"
                        >
                        <el-option label="全部" value="" />
                            <el-option
                              v-for="item in yhlist"
                               :key="item.UserID"
                              :label="item.UserName"
                              :value="item.UserID"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间范围">
                        <el-date-picker
                          style="width:280px;"
                          v-model="dateRange"
                          type="daterange"
                          value-format="YYYY-MM-DD"
                          unlink-panels
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="getDataFour">统计</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div  class="firstDiv">
            <div class="grid-content img1">
                <div class="staticTitle">本周转贷情况</div>
                <div class="staticContent">
                    <div>转贷数量：<span style="color:#ff6600;font-weight: bold">{{weekStatistic.num}}</span>&nbsp;&nbsp;笔</div>
                    <div>转贷金额：<span  style="color:#ff6600;font-weight: bold">{{weekStatistic.sum==null?0:weekStatistic.sum}}</span>&nbsp;&nbsp;万元</div>
                </div>
            </div>
            <div class="grid-content img2">
                <div class="staticTitle">本月转贷情况</div>
                <div class="staticContent">
                    <div>转贷数量：<span style="color:#ff6600;font-weight: bold">{{monthStatistic.num}}</span>&nbsp;&nbsp;笔</div>
                    <div>转贷金额：<span  style="color:#ff6600;font-weight: bold">{{monthStatistic.sum==null?0:monthStatistic.sum}}</span>&nbsp;&nbsp;万元</div>
                </div>
            </div>
            <div class="grid-content img3">
                <div class="staticTitle">本年度转贷情况</div>
                <div class="staticContent">
                    <div>转贷数量：<span style="color:#ff6600;font-weight: bold">{{yearStatistic.num}}</span>&nbsp;&nbsp;笔</div>
                    <div>转贷金额：<span  style="color:#ff6600;font-weight: bold">{{yearStatistic.sum==null?0:yearStatistic.sum}}</span>&nbsp;&nbsp;万元</div>
                </div>
            </div>
             <div class="grid-content img4">
                <div class="staticTitle">累计转贷情况</div>
                <div class="staticContent">
                    <div>转贷数量：<span style="color:#ff6600;font-weight: bold">{{allStatistic.num}}</span>&nbsp;&nbsp;笔</div>
                    <div>转贷金额：<span  style="color:#ff6600;font-weight: bold">{{allStatistic.sum==null?0:allStatistic.sum}}</span>&nbsp;&nbsp;万元</div>
                </div>
            </div>
        </div>
        <div  class="secondDiv">
            <div class="custom-title">
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item label="时间范围">
                        <el-date-picker
                          @change="getChartData1"
                          style="width:280px;"
                          v-model="dateRange1"
                          type="monthrange"
                          value-format="YYYY-MM"
                          unlink-panels
                          range-separator="至">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
            </div>
            <div class="echarts1" id="echarts1" style="padding-left: 20px;"></div>
        </div>
        <div  class="thirdDiv">
            <div class="custom-title">
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item label="时间范围">
                        <el-date-picker
                          style="width:280px;"
                          v-model="dateRange2"
                          type="daterange"
                          value-format="YYYY-MM-DD"
                          unlink-panels
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="展示项目">
                        <el-select
                          v-model="zsflag"
                          style="width: 120px"
                        >
                        <el-option label="银行初审" value="1" />
                        <el-option label="转贷经办" value="2" />
                        <el-option label="申请类型" value="3" />
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="getChartData2">统计</el-button>
                    </el-form-item> 
                </el-form>
            </div>
            <div class="echarts1" id="echarts2"></div>
        </div>
    </div>
</template>

<script>
import indexJs from "./index.js";
  export default indexJs;
</script>

<style scoped>
@import url(./assets/style/style.less);
</style>
